import { BrowserRouter, Routes, Route } from "react-router";
import HomePage from "./Pages/HomePage";
import DashboardPage from "./Pages/DashboardPage";
import LoginPage from "./Pages/LoginPage";
import ReportPage from "./Pages/ReportPage";
import { createClient } from "@supabase/supabase-js";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import "./assets/css/fonts.css"

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabase = createClient(supabaseUrl, supabaseKey);

const App = () => {
    const [session, setSession] = useState("");
    
      useEffect(() => {
        supabase.auth.getSession()
        .then(({ data: { session } }) => {
          setSession(session);
        });
      }, []);
    const handleLogout = async () => {
        const { error } = await supabase.auth.signOut();
            setSession("");
            if (error) {
                console.error("Logout error:", error.message);
            } else {
                console.log("Logged out");
            }
    };
    
  return (
    <BrowserRouter>
    <Routes>
         <Route path="/" element={ <>{session ? <HomePage session={session} handleLogout={handleLogout} supabase={supabase} /> : <LoginPage  supabase={supabase} /> }</>} /> 
         <Route path="/Dashboard" element={ <>{session  ?  <DashboardPage session={session} handleLogout={handleLogout} supabase={supabase} /> :  <LoginPage  supabase={supabase} />} </>} /> 
         <Route path="/Report" element={ <>{session  ?  <ReportPage session={session} handleLogout={handleLogout} supabase={supabase} /> :  <LoginPage  supabase={supabase} />} </>} /> 
    </Routes>
  </BrowserRouter>
  )
}

export default App
